export const imageValidation = (file: File) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    alert('You can only upload JPG/PNG file');
    return false;
  }
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    alert('Image must smaller than 10MB');
    return false;
  }
  return isJpgOrPng && isLt10M;
};

export const audioFileValidation = (file: File) => {
  const isMp3orWav = file.type === 'audio/mpeg' || file.type === 'audio/wav';
  if (!isMp3orWav) {
    alert('You can only upload MP3 file');
    return false;
  }
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    alert('Audio must smaller than 10MB');
    return false;
  }
  return isMp3orWav && isLt10M;
};
